import AppConfig from '@/AppConfig';
import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: AppConfig.SENTRY_DSN,
    beforeSend(event) {
      event.tags = { app: AppConfig.APP_NAME };
      return event;
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['ui-services-etelehealth-triage'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
